import { AdminServicesService } from './admin-services.service';

import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, switchMap, filter, take } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
// import { url } from 'inspector';

@Injectable({
  providedIn: 'root'
})
export class RestService implements HttpInterceptor {

  // url : string;
  
  public baseurl = "https://9h6bwbaajf.execute-api.ap-south-1.amazonaws.com/dev/";
  // public baseurl="http://192.168.1.104:2528/";
  citizenData: string;

  // public localUrl = "http://192.168.1.104:2528/";

  constructor(private http: HttpClient,
              private toastr: ToastrService, 
              private userservice: AdminServicesService, 
              private router: Router) { 
                // this.citizenData = localStorage.getItem('data');
                // console.log(this.citizenData);
              }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // if(this.router.url.includes('basic')){
    //   if(!this.citizenData)
    //   {
    //     console.log("Ramki");
    //     this.router.navigate(['home']);
    //   }
    // }
    if (localStorage.getItem('accessToken')) {
      request = this.addToken(request, localStorage.getItem('accessToken'));
    }
    return next.handle(request).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && (error.status == 406)) {
        this.toastr.error(error.error.message);
        this.router.navigate(['/login-admin']);
        // return this.handle401Error(request, next);
      } else if (error instanceof HttpErrorResponse && (error.status == 405)) {
        this.toastr.error(error.error.message);
        localStorage.clear();
        this.router.navigate(["login-admin"]);
      } else {
        this.toastr.error(error.error.message);
        return throwError(error);
      }
    }));
  }

  handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return this.refreshToken().pipe(
      switchMap((refresh: any) => {
        let token = refresh.accesstoken;
        localStorage.setItem('accessToken', token);
        return next.handle(this.addToken(request, token));
      }));
  }


  refreshToken() {
    return this.http.post(`${this.baseurl}relogin_post`, { 'refreshtoken': localStorage.getItem('refreshToken') })
  }

  addToken(request: HttpRequest<any>, token: any): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        // 'Content-Type': 'application/json',
        'authorization': 'Bearer ' + token,
      }
    });
  }
}
